<!-- 下载匣 -->
<template>
  <div class="taoist">
    <!-- 展示列表 -->
    <div v-for="(one, i) in contentList1" :key="i">
      <div class="content contentTitle">{{ one.cate_name }}</div>
      <div
        class="content flex-between"
        v-for="(item, index) in one.lists"
        :key="index"
      >
        <div class="nameW">{{ item.title }}</div>
        <!-- <div class="color047BCD" @click="downLoad({url:item.file_url,title:item.title})"><a :href="'http://chanxue.b.langqiyun.cn/'+item.file_url" style="text-decoration: none;color: #000000;">{{item.format}}</a></div> -->
        <div class="color047BCD">
          <a
            @click="downLoad(item)"
            style="text-decoration: none; color: #047bcd"
            >{{ item.format }}</a
          >
        </div>
        <!-- <div class="time">{{item.data}}</div> --><!-- 此行时修改时注释的 -->
      </div>
      <barF5></barF5>
    </div>

    <!-- 去除底部button所占的位置 -->
    <!-- <empty></empty> -->
    <!-- 底部button -->
    <!-- <footer>
      <Button></Button>
    </footer> -->
  </div>
</template>

<script>
// import {downloadFile} from '../../api/apis'
import { getCateList, getDownLoadList } from "../../api/apis";
import barF5 from "../../components/barF5"; //空隙bar
import empty from "../../components/empty";
import Button from "../../components/button"; //返回首頁
export default {
  name: "活动讯息",
  components: {
    empty,
    Button,
    barF5,
  },

  props: {
    // contentList: {
    //     type: Array,
    //     default: () => []
    // }
  },
  watch: {
    // contentList(res) {
    //     if (Array.isArray(res)) {
    //         for (let item of res) {
    //             item.lists = getTimeBeforeDay(item.lists, 'data');
    //         }
    //     }
    //     this.contentList1 = res;
    // }
  },
  data() {
    return {
      // baseUrl:  "http://chanxue.b.langqiyun.cn/api/index/fileDownload?",
      baseUrl: "http://www.anhsiangchan.org.tw/api/index/fileDownload",
      contentList1: [],
      // contentList: [{
      //         name: "關於力量的一點體會",
      //         type: "Word格式",
      //         time: "2019-09-19"
      //     },
      //     {
      //         name: "關於力量的一點體會",
      //         time: "2019-09-19",
      //         type: "Word格式",
      //     },
      //     {
      //         name: "關於力量的一點體會",
      //         type: "Word格式",
      //         time: "2019-09-19"
      //     },
      // ]
    };
  },
  methods: {
    //下载资源
    downLoad(item) {
      if (item.new_link_mobile) {
        window.open(item.new_link_mobile);
      } else if(item.file_url) {
        window.location.href =
          this.baseUrl + `?url=${item.file_url}&title=${item.title}`;
      }
    },
  },
  mounted() {
    //页面加载时就获取所有页面的数据
    getCateList().then((res) => {
      getDownLoadList(res[4][2].id).then((res) => {
        if (Array.isArray(res)) {
          for (let item of res) {
            // item.lists = getTimeBeforeDay(item.lists, 'data');
            item.lists = item.lists;
          }
        }
        this.contentList1 = res || {};
        //   console.log(this.contentList1)
      });
    });
  },
};
</script>

<style scoped>
.taoist {
  color: #333333;
}

.titleLeft {
  font-size: 0.8rem;
  line-height: 1.8rem;
  font-size: 0.85rem;
}

.content {
  /* height: 2.4rem; */
  border-bottom: 1px dashed #dfdfdf;
  line-height: 1.8rem;
  margin-left: 0.64rem;
  margin-right: 0.64rem;
  /* padding-left: 0.64rem;
      padding-right: 0.64rem; */
  font-size: 0.85rem;
}

.contentTitle {
  font-weight: bold;
  line-height: 1.8rem;
  font-size: 0.8rem;
  font-size: 0.85rem;
}

.time {
  color: #999999;
}

.nameW {
  width: 14rem; /*10rem*/
  flex-shrink: 0;
  line-height: 1.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* overflow: hidden; */
}

.color047BCD {
  color: #047bcd;
}
</style>